import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static targets = ["dismiss"];

  /*
   * Lifecycle methods
   */
  dismissTargetConnected(target: HTMLElement) {
    target.addEventListener("click", this.eventDismissClick);

    this.element.classList.add("puts-notification--dismissible");
  }
  dismissTargetDisconnected(target: HTMLElement) {
    target.removeEventListener("click", this.eventDismissClick);
  }

  /*
   * Event handlers
   */
  eventDismissClick = (event: PointerEvent) => {
    event.preventDefault();
    event.stopPropagation();
    this.dismiss();
  };

  /*
   * Public methods
   */
  public dismiss() {
    this.element.remove();
  }
}
